import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import Home from "./views/home/home.vue";
import { Message } from "element-ui";
Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: "/registration",
      name: "registration",
      component: () => import("./views/system/register.vue")
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./views/login/login.vue")
    },
    {
      path: "/verification",
      name: "verification",
      component: () => import("./views/login/verification.vue")
    },
    {
      path: "/catalog",
      name: "catalog",
      component: () => import("./views/catalog/catalog.vue")
    },
    {
      path: "/oeSearch",
      name: "oeSearch",
      component: () => import("./views/oeSearch/oeSearchList.vue")
    },
    {
      path: "/oeSearchDetail",
      name: "oeSearchDetail",
      component: () => import("./views/oeSearch/oeSearchDetail.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (window._hmt && to.path) {
    window._hmt.push(["_trackPageview", to.fullPath]);
  }
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    if (sessionStorage.getItem("token")) {
      // localStorage获取当前的token是否存在
      next();
    } else {
      next({ path: "/verification" });
    }
  } else {
    next();
  }
});

export default router;
